/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS103: Rewrite code to no longer use __guard__
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import EntryStore from 'stores/EntryStore';
import EntryActions from 'actions/EntryActions';
import ReviewConstants from 'notebook/reviews/ReviewConstants';
import ProxyFile from 'folder-items/ProxyFile';
import {DocumentBanner} from 'notebook/components/banners/DocumentBanner';
import ModelTypeConstants from 'constants/ModelTypeConstants';

class Entry extends ProxyFile {
  static initClass() {
    this.prototype.proxiedField = 'entry';
  }

  getStore() {
    return EntryStore;
  }

  entryProtocols() {
    return this.proxied().entryProtocols;
  }

  getEntryNote() {
    return EntryStore.getNote(this.id);
  }

  collaboratorIds() {
    return this.get('collaboratorIds');
  }

  templateVersionId() {
    return this.proxied().templateVersionId;
  }

  templateUrl() {
    return this.proxied().templateUrl;
  }

  templateVersionTimestamp() {
    return this.proxied().templateVersionTimestamp;
  }

  isStale() {
    return this.proxied().isStale;
  }

  allowEdits() {
    return (
      super.allowEdits() &&
      !Array.from(ReviewConstants.LOCKED_STATUSES).includes(__guard__(this.review(), (x) => x.status)) &&
      !this.isDirty()
    );
  }

  getState() {
    return this.getStore().getEditorState(this.id);
  }

  openLatestVersion() {
    EntryActions.open(this.id);
  }

  // TODO T3917: refactor notifications and setBanner to use same text
  setBanner() {
    if (Array.from(ReviewConstants.LOCKED_STATUSES).includes(__guard__(this.review(), (x) => x.status))) {
      this.setBannerText(
        <DocumentBanner.ReviewLocked
          status={this.review().status}
          docType={ModelTypeConstants.ENTRY}
          isLatest={this.isLatest()}
          onNavigateToLatest={() => this.openLatestVersion()}
        />
      );
    } else if (this.lockedFromExternalChange()) {
      this.setBannerText(<DocumentBanner.ExternalChangeLocked isUnsaved={this.isUnsaved()} />);
    } else if (!this.isLatest() || this.isDirty()) {
      this.setBannerText(
        <DocumentBanner.PreviousVersion
          docType={ModelTypeConstants.ENTRY}
          isEvaluationPersisted={Boolean(this.proxied()?.note?.noteRuntimeSnapshot?.isEvaluationPersisted)}
          onNavigateToLatest={() => this.openLatestVersion()}
        />
      );
    } else if (!this.writable()) {
      if (this.isArchived()) {
        this.setBannerText(<DocumentBanner.Archived docType={ModelTypeConstants.ENTRY} />);
      } else {
        this.setBannerText(<DocumentBanner.ReadOnly docType={ModelTypeConstants.ENTRY} />);
      }
    } else {
      this.setBannerText(null);
    }
  }

  load(param) {
    if (param == null) {
      param = {};
    }
    const {versionId, deferred} = param;
    if (this.proxied() != null && versionId != null) {
      // If it's already loaded and they are trying to load a version
      EntryActions.loadVersion(this.id, versionId, {deferred});
    } else {
      // Otherwise, trigger a fresh open.
      EntryActions.open(this.id, {versionId, deferred});
    }
  }

  review() {
    return this.proxied().review;
  }

  addProtocol(protocol) {
    EntryActions.addProtocol(this.id, this.proxied(), protocol);
  }

  updateProtocol(protocolCid, op) {
    EntryActions.updateProtocol(this.id, this.proxied(), protocolCid, op);
  }

  removeProtocol(protocolCid) {
    EntryActions.removeProtocol(this.id, this.proxied(), protocolCid);
  }

  revertProtocol(protocol, selectionData) {
    EntryActions.revertProtocol(this.id, this.proxied(), protocol, selectionData);
  }

  reorderProtocols(cids) {
    EntryActions.reorderProtocols(this.id, this.proxied(), cids);
  }

  setTagSchema(tagSchema) {
    EntryActions.postServerUpdate(this.id, {tagSchema});
  }

  setTags(tags) {
    EntryActions.postServerUpdate(this.id, {tags});
  }

  setAuthors(authors) {
    EntryActions.postServerUpdate(this.id, {authors});
  }

  setArchiveRecord(archiveRecord) {
    EntryActions.postServerUpdate(this.id, {archiveRecord});
  }

  setPermissions(permissions) {
    EntryActions.postServerUpdate(this.id, {permissions});
  }

  cleanUp() {
    super.cleanUp();
    EntryActions.close(this.id);
  }
}
Entry.initClass();

export default Entry;

function __guard__(value, transform) {
  return value != null ? transform(value) : undefined;
}
